import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/Login.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginUser } from "../services/apiServices";
import { LuEyeClosed } from "react-icons/lu";
import { LuEye } from "react-icons/lu";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/ethiopia");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await loginUser(email, password);

      if (!response || !response.token) {
        toast.error(response?.message || "Incorrect Credentials!");
      } else {
        setLoading(false);
        localStorage.setItem("token", response.token);
        // localStorage.setItem("user_admin", response.user_admin);
        localStorage.setItem("email", response.email);
        if (response.loginTimestamp) {
          localStorage.setItem("loginTimestamp", response.loginTimestamp);
        }
         if (response.role) {
          localStorage.setItem("role", response.role);
        }
        toast.success(response.message || "Login Successful!");
        setEmail(""); 
        setPassword(""); 
        setTimeout(() => {
          navigate("/ethiopia");
        }, 2000);
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error("Something went wrong. Please try again.");
    }
     finally {
    setLoading(false);
  }
  };

  return (
    <div className="main">
      <ToastContainer />
      <div className="login-container">
        <div className="login-box">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-container">
              <label>Email</label>
              <input
                type="email"
                value={email}
                autoComplete="current-email"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="input-container">
              <label>Password</label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  className="view-password-btn"
                  onClick={() => setShowPassword(!showPassword) }
                  disabled={loading} 
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <LuEye /> : <LuEyeClosed />}
                </button>
              </div>
            </div>
            <button disabled={loading} type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
